import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Row, Table, Spinner } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';

import { createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import PaginationComponent from "../components/PaginationComponent";
import MySearchOption from "../components/MySearchOption";
import MyDateRenderer from "../components/MyDateRenderer";
import CustomerCategoryLabel from "../components/CustomerCategoryLabel";

import { useDispatch, useSelector } from "react-redux";
import * as idiInspectionActions from "../actions/IdiInspectionActions";

const IdiInspectionSearch  = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const loading = useSelector((state) => state.idiinspection.loading);
    const list = useSelector((state) => state.idiinspection.list);
    const filter = useSelector((state) => state.idiinspection.filter);
    const user = useSelector((state) => state.login.user);

    const doSearch = () => {
        var copy_filter = createDeepClone(filter);
        
        if(copy_filter.pageIndex == 1) {
            dispatch(idiInspectionActions.loadIdiInspectionSearch(filter, navigate));
        }
        else {
            copy_filter.pageIndex = 1;
            dispatch(idiInspectionActions.setIdiInspectionFilter(copy_filter));
        }
    }

    React.useEffect(() => {
		dispatch(idiInspectionActions.loadIdiInspectionSearch(filter, navigate));
    }, [filter.pageIndex]);

    const onFilterChange = (name, value) => {
        var copy_filter = createDeepClone(filter);
        copy_filter[name] = value;
        dispatch(idiInspectionActions.setIdiInspectionFilter(copy_filter));
    }
    
    const onPageChange = (page) => {
        var copy_filter = createDeepClone(filter);
        copy_filter.pageIndex = page;
        dispatch(idiInspectionActions.setIdiInspectionFilter(copy_filter));
    }

    const exportToExcel = () => {
        dispatch(idiInspectionActions.downloadIdiInspectionSearch(filter, "IDI Inspections.xlsx"));
    }
    
    return(
        <Fragment>
            <div className="page-content">
            <Container fluid>
                    <BreadCrumb title="IDI Inspection Search" />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-3">
                                        <Col xxl={10} md={12}>
                                            <MySearchOption
                                                placeholder={"Search for IDI Inspections..."}
                                                value={filter.search}
                                                searchList={list.searchList || []}
                                                fieldName="search"
                                                onChange={onFilterChange}
                                            />
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <button type="button" className="btn btn-primary btn-label w-100" 
                                                disabled={loading}
                                                onClick= {() => doSearch()}
                                            >
                                                <i className="ri-search-eye-line label-icon align-middle"></i> Search
                                            </button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardLoader loading={loading} />
                                <CardBody>
                                    <div className="table-responsive table-card">
                                        <Table className="table-hover align-middle mb-0">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th style={{width:10}}>&nbsp;</th>
                                                    <th>Inspection #</th>
                                                    <th>Status</th>
                                                    <th>State Name</th>
                                                    <th>Start Date</th>
                                                    <th>End Date</th>
                                                    <th>Report Type</th>
                                                    <th>Action Date</th>
                                                    <th>Date Added</th>
                                                    <th>Added By</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.dataList.map(function(item, index){
                                                    return(
                                                        <tr key={index}>
                                                            <td>
                                                                <div className="flex-shrink-0">
                                                                    <ul className="list-inline tasks-list-menu mb-0">
                                                                        <li className="list-inline-item">
                                                                            <Link to={`/idi-inspection-edit/${item.id}`}>
                                                                                <i className="ri-pencil-fill fs-20 align-bottom text-primary"></i>
                                                                            </Link>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                            <td style={{whiteSpace: "nowrap"}}>
                                                                <div>{item.inspectionNumber}</div>
                                                            </td>
                                                            <td><span className="badge" style={{backgroundColor: item.statusColorCode}}>{item.statusName}</span></td>
                                                            <td>{item.stateName}</td>
                                                            <td><MyDateRenderer value={item.startDate} /></td>
                                                            <td><MyDateRenderer value={item.endDate} /></td>
                                                            <td>
                                                                {item.isRd5Report && <span className="badge bg-primary me-1">RD5</span>}
                                                                {item.isRd7Report && <span className="badge bg-secondary me-1">RD7</span>}
                                                                {item.isInrReport && <span className="badge bg-success me-1">INR</span>}
                                                                {item.isRd3Report && <span className="badge bg-danger me-1">RD3</span>}
                                                                {item.isRd6Report && <span className="badge bg-warning me-1">RD6</span>}
                                                                {item.isBaladyReport && <span className="badge bg-info me-1">BALADY</span>}
                                                                {item.isNoReport && <span className="badge bg-light me-1">NO REPORT</span>}
                                                            </td>
                                                            <td><MyDateRenderer value={item.lastActionDate} /></td>
                                                            <td><MyDateRenderer value={item.dateAdded} /></td>
                                                            <td>{item.addedBy}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <Row>
                                        <Col lg={12}>
                                            <PaginationComponent
                                                total={list.totalCount}
                                                currentPage={filter.pageIndex}
                                                onPageChange={page => onPageChange(page)}
                                                onExportToExcel={() => exportToExcel()}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default IdiInspectionSearch;